function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import qs from 'qs';
import { Loader } from '@googlemaps/loader';
import { consultationReasons } from '../../util/consultation_reasons';
import { languages } from '../../util/languages';
import DietitianCard from './DietitianCard.vue';
export default {
  props: ['title', 'body', 'clientTypes', 'serviceTypes'],
  data: function data() {
    return {
      isLoading: false,
      consultationReason: '',
      clientType: '',
      serviceType: '',
      language: '',
      postalCode: '',
      consultationReasons: consultationReasons,
      languages: languages,
      results: [],
      map: null,
      markers: [],
      errors: [],
      defaultLngLat: ['-73.5722940153426', '45.50586207517614'],
      searchDone: false
    };
  },
  components: {
    DietitianCard: DietitianCard
  },
  mounted: function mounted() {
    this.initializeMap();
    var searchParams = new URLSearchParams(window.location.search);

    if (_toConsumableArray(searchParams).length > 0) {
      var _searchParams$get, _searchParams$get2, _searchParams$get3, _searchParams$get4, _searchParams$get5;

      this.consultationReason = (_searchParams$get = searchParams.get('consultation_reason')) !== null && _searchParams$get !== void 0 ? _searchParams$get : '';
      this.clientType = (_searchParams$get2 = searchParams.get('client_type')) !== null && _searchParams$get2 !== void 0 ? _searchParams$get2 : '';
      this.serviceType = (_searchParams$get3 = searchParams.get('service_type')) !== null && _searchParams$get3 !== void 0 ? _searchParams$get3 : '';
      this.language = (_searchParams$get4 = searchParams.get('language')) !== null && _searchParams$get4 !== void 0 ? _searchParams$get4 : '';
      this.postalCode = (_searchParams$get5 = searchParams.get('postal_code')) !== null && _searchParams$get5 !== void 0 ? _searchParams$get5 : '';
      this.fetchDietitians();
    }
  },
  methods: {
    initializeMap: function initializeMap() {
      var _this = this;

      var mapEl = document.getElementById('map');
      var loader = new Loader({
        apiKey: tolle_ajax_params.google_maps_api_key,
        version: 'weekly'
      });
      loader.load().then(function () {
        if (mapEl) {
          var mapOptions = {
            center: new google.maps.LatLng(Number(_this.defaultLngLat[1]), Number(_this.defaultLngLat[0])),
            zoom: 12,
            disableDefaultUI: true,
            styles: [{
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{
                visibility: 'off'
              }]
            }]
          };
          _this.map = new google.maps.Map(mapEl, mapOptions);
        }
      }).catch(function (e) {
        throw new Error(e);
      });
    },
    fetchDietitians: function fetchDietitians() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reasons, data, reason, _data, options;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Clear the markers as to not clutter the map with old markers.
                _this2.clearMapMarkers();

                _this2.errors = [];
                _this2.isLoading = true;
                reasons = [];
                _this2.searchDone = false;

                if (_this2.consultationReason) {
                  _this2.results = [];
                  data = {
                    action: 'search_dn',
                    consultation_reason: _this2.consultationReason,
                    client_type: _this2.clientType,
                    service_type: _this2.serviceType,
                    language: _this2.language,
                    postal_code: _this2.postalCode
                  };
                  reason = _this2.consultationReasons.find(function (reason) {
                    return reason.title == _this2.consultationReason;
                  });
                  reasons = reason.children;

                  if (reasons.length > 0) {
                    reasons.forEach(function (reason, index) {
                      var data = {
                        action: 'search_dn',
                        consultation_reason: reason,
                        client_type: _this2.clientType,
                        service_type: _this2.serviceType,
                        language: _this2.language,
                        postal_code: _this2.postalCode
                      };

                      var response = _this2.request(data);

                      response.then(function (result) {
                        if (result) {
                          result.forEach(function (r) {
                            if (!_this2.results.find(function (rr, index, array) {
                              return r.numeroPermis === rr.numeroPermis;
                            })) {
                              _this2.results.push(r);
                            }
                          });

                          _this2.setMapMarkers(); // We focus the map here to ensure we have the data
                          // from the asynchronous call and on the first iteration
                          // since we get the first dietitian anyways.


                          if (index === 0) {
                            _this2.focusFirstResult();
                          }
                        }
                      });
                    });
                    window.history.pushState({}, null, window.location.pathname + '?' + qs.stringify(data));
                    _this2.isLoading = false;
                  }
                } else {
                  _data = {
                    action: 'search_dn',
                    consultation_reason: _this2.consultationReason,
                    client_type: _this2.clientType,
                    service_type: _this2.serviceType,
                    language: _this2.language,
                    postal_code: _this2.postalCode
                  };
                  options = {
                    method: 'POST',
                    headers: {
                      'content-type': 'application/x-www-form-urlencoded'
                    },
                    body: qs.stringify(_data)
                  };
                  window.history.pushState({}, null, window.location.pathname + '?' + qs.stringify(_data));
                  fetch(tolle_ajax_params.admin_url, options).then(function (res) {
                    return res.json();
                  }).then(function (json) {
                    _this2.results = json.data;

                    _this2.setMapMarkers();

                    _this2.focusFirstResult();
                  }).catch(function (err) {
                    return console.error("error: ".concat(err));
                  }).finally(function () {
                    _this2.isLoading = false;
                  });
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setMapMarkers: function setMapMarkers() {
      var _this3 = this;

      this.searchDone = true;

      var _loop = function _loop() {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            index = _Object$entries$_i[0],
            result = _Object$entries$_i[1];

        var _loop2 = function _loop2() {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              index = _Object$entries2$_i[0],
              location = _Object$entries2$_i[1];

          var coordinates = location.coordonneeGeographique.split(';');
          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(coordinates[1], coordinates[0]),
            map: _this3.map,
            icon: "".concat(tolle_ajax_params.public_path, "/images/pointer.svg"),
            id: result.numeroPermis
          });
          google.maps.event.addListener(marker, 'mouseover', function (e) {
            var memberCard = document.getElementById("member-".concat(result.numeroPermis));
            var sideBar = document.querySelector('.results-list');
            memberCard.classList.add('active');
            sideBar.scrollTo({
              top: memberCard.offsetTop - 50,
              behavior: 'smooth'
            });
            marker.setIcon("".concat(tolle_ajax_params.public_path, "/images/pointer-active.svg"));
          });
          google.maps.event.addListener(marker, 'mouseout', function (e) {
            var memberCard = document.getElementById("member-".concat(result.numeroPermis));
            memberCard.classList.remove('active');
            marker.setIcon("".concat(tolle_ajax_params.public_path, "/images/pointer.svg"));
          });

          _this3.markers.push(marker);
        };

        for (var _i2 = 0, _Object$entries2 = Object.entries(result.lieuxExercicePratiquePrivee); _i2 < _Object$entries2.length; _i2++) {
          _loop2();
        }
      };

      for (var _i = 0, _Object$entries = Object.entries(this.results); _i < _Object$entries.length; _i++) {
        _loop();
      }
    },
    clearMapMarkers: function clearMapMarkers() {
      this.markers.map(function (marker) {
        return marker.setMap(null);
      });
      this.markers = [];
    },
    focusFirstResult: function focusFirstResult() {
      var lngLat = this.defaultLngLat;

      if (this.results.length > 0) {
        var location = this.results[0];
        lngLat = location.lieuxExercicePratiquePrivee[0].coordonneeGeographique.split(';');
      }

      this.map.setCenter({
        lat: Number(lngLat[1]),
        lng: Number(lngLat[0])
      });
      this.map.setZoom(16);
    },
    request: function request(data) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var options, res, json;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = {
                  method: 'POST',
                  headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                  },
                  body: qs.stringify(data)
                };
                _context2.prev = 1;
                _context2.next = 4;
                return fetch(tolle_ajax_params.admin_url, options);

              case 4:
                res = _context2.sent;
                _context2.next = 7;
                return res.json();

              case 7:
                json = _context2.sent;
                return _context2.abrupt("return", json.data);

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", console.error("error: ".concat(_context2.t0)));

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 11]]);
      }))();
    }
  }
};